import React from 'react';
import { Box } from '@chakra-ui/react';
import { walletColors } from '../walletTheme';

/** Flat ink hero card (20px radius); lime fills inside read well on ink. */
const WalletHeroChrome: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    position="relative"
    overflow="hidden"
    borderRadius="20px"
    bg={walletColors.heroGradient}
    px="20px"
    pt="20px"
    pb="18px"
    color="white"
    fontFamily="display"
  >
    {children}
  </Box>
);

export default WalletHeroChrome;
